import { SessionActorType } from "@bcasmart/doxecure-commons/doxecureTypes";

import { Dashboard } from "@containers/generics/Dashboard";
import { useAuthContext } from "@hooks/useAuthContext";
import { okOrError, optlog, defaultSectionInformations } from "@utils/functions";
import { BaseViewProps } from "@/utils/TypesAndConstants";

export const ExpiredDocumentsView = (props: BaseViewProps) => {
    const { lockedAccount } = props;
    const { connectedProfileId } = useAuthContext();
    optlog(`+++ ExpiredDocumentsView initialized with profile ID '${connectedProfileId}'`) ;

    return okOrError(
        connectedProfileId,
        (<Dashboard 
            title="Documents expirés"
            emptyMessage="Pas de documents expirés"
            category="expired"
            roles={[SessionActorType.Creator, SessionActorType.Expeditor, SessionActorType.Approver, SessionActorType.Signer]}
            lockedAccount={lockedAccount}
            sectionInfos={defaultSectionInformations} 
        />),
        false,
        "Impossible d'afficher la liste des documents à signer expirés car l'identifiant de profil de la personne connectée n'a pas pu être récupéré.",
        "Connexion invalide"
    ) ;
};
